import CryptoJS from 'crypto-js';

// AES 密钥 (32字符)
const AES_KEY = import.meta.env.VITE_AES_KEY;

// AES 加密
export function aesEncrypt(txt) {
    const encrypted = CryptoJS.AES.encrypt(txt, CryptoJS.enc.Utf8.parse(AES_KEY), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
}

// AES 解密
export function aesDecrypt(txt) {
    const decrypted = CryptoJS.AES.decrypt(txt, CryptoJS.enc.Utf8.parse(AES_KEY), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
}
